angular.module('app').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/app/partials/desktopRuler/views/apDesktopRuler.html',
    "<div class=\"container-fluid container-flush ap-application-margin ap-application-content desktop-ruler-height\">\r" +
    "\n" +
    "    <div class=\"desktop-ruler-margin-left\">P-L</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">01</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">02</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">03</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">04</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">05</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">06</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">07</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">08</div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">09</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">10</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">11</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">12</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">13</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">14</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">15</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-gutter\"></div>\r" +
    "\n" +
    "    <div class=\"desktop-ruler-column-left\">16</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"desktop-ruler-margin-right\">P-R</div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/partials/footer/views/apFooter.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"ap-footer ap-application-padding\">\r" +
    "\n" +
    "        <div class=\"col-xs-4\">\r" +
    "\n" +
    "            <span>\r" +
    "\n" +
    "                 {{'Powered by' | translate}}&nbsp;&nbsp;\r" +
    "\n" +
    "                <img src=\"images/spacer.png\" class=\"ap-footer-logo\">\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-8\">\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <span class=\"pull-right\">\r" +
    "\n" +
    "                        <a class=\"clickable\" ng-click=\"viewPrivacyPolicyImage()\">{{'Privacy Policy' | translate}}</a>\r" +
    "\n" +
    "                        <span ng-if=\"apFooter.PatientAuthenticated\">\r" +
    "\n" +
    "                            &nbsp;&nbsp;|&nbsp;&nbsp;\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <span class=\"pull-right\">\r" +
    "\n" +
    "                      &copy; {{'Aprima Medical Software 2015.  All rights reserved.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/partials/header/views/apHeader.html',
    "\r" +
    "\n" +
    "<div class=\"facility-portal ap-header flexbox flexbox-horizontal-center\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"flexbox-pull-left\">\r" +
    "\n" +
    "        <span class=\"header-facility-portal\">\r" +
    "\n" +
    "            Facility P<em>o</em>rtal\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "        <span class=\"header-title\" ng-if=\"!apHeader.practiceName\">\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"flexbox-pull-right\">\r" +
    "\n" +
    "        <span class=\"header-dropdown header-menu header-item flush-right\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"dropdown\">\r" +
    "\n" +
    "                <button class=\"btn btn-header dropdown-toggle btn-flush-right btn-header-image no-image\" type=\"button\" id=\"header-context-menu\" data-toggle=\"dropdown\" aria-expanded=\"true\">\r" +
    "\n" +
    "                    <span class=\"header-text1\">{{'Welcome,'|translate}}&nbsp;&nbsp;</span>\r" +
    "\n" +
    "                    <span class=\"header-text2\">{{apHeader.activeUserFullName | translate}} </span>\r" +
    "\n" +
    "                    <span class=\"caret\"></span>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <ul class=\"dropdown-menu dropdown-menu-right no-image\" role=\"menu\" aria-labelledby=\"header-context-menu\">\r" +
    "\n" +
    "                    <li role=\"presentation\">\r" +
    "\n" +
    "                        <a id=\"context-signout\" role=\"menuitem\" tabindex=\"3\" ng-click=\"signOff()\">{{'Sign Out' | translate}}</a>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "                </ul>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "          </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"ap-mobile-menu-button\" ng-click=\"toggleMobileNav()\">\r" +
    "\n" +
    "            <span class=\"glyphicon glyphicon-menu-hamburger\"></span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <span class = \"header-item pull-right center-text\" ng-if=\"loading\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/partials/mobileNav/views/apMobileNav.html',
    "<!--Begin mobile nav bar-->\r" +
    "\n" +
    "<div class=\"dropdown ap-mobile-nav slide-in\" collapse=\"!showMobileNav\" ng-cloak>\r" +
    "\n" +
    "  <div ng-if=\"showMobileNav\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"ap-mobile-nav-item ap-mobile-nav-welcome flexbox flexbox-horizontal-center\">\r" +
    "\n" +
    "        {{:: 'Welcome' | translate}}, {{ ::headerData.activeUserFullName }}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "      <div class=\"ap-mobile-nav-item ap-mobile-nav-signout flexbox flexbox-horizontal-center\" ng-click=\"signOff()\">\r" +
    "\n" +
    "          <i class=\"fa fa-power-off\"></i>\r" +
    "\n" +
    "          <span class=\"nav-item\">\r" +
    "\n" +
    "        {{:: 'Sign out' | translate}}\r" +
    "\n" +
    "      </span>\r" +
    "\n" +
    "      </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/partials/toolbar/views/apToolbar.html',
    "<div class=\"btn-group btn-group-justified ap-toolbar ap-application-margin ap-application-content hidden-print\" role=\"group\" ng-cloak>\r" +
    "\n" +
    "        <div class=\"btn-group\"\r" +
    "\n" +
    "             ng-class=\"(!toolbarItem || toolbarItem === 'welcome')? 'btn-group-toolbar-selected btn-group-flush-left' : 'btn-group-toolbar btn-group-flush-left'\"\r" +
    "\n" +
    "             role=\"group\">\r" +
    "\n" +
    "                <button\r" +
    "\n" +
    "                        class=\"btn btn-nowrap btn-toolbar underline\"\r" +
    "\n" +
    "                        id=\"welcome-btn\"\r" +
    "\n" +
    "                        ng-if=\"notifications.Welcome.IsActive && !blankToolbar.BackToHome.IsActive\"\r" +
    "\n" +
    "                        data-transition-to=\"{appRoute: 'dashboard'}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg home-selected\" ng-if=\"(!toolbarItem || toolbarItem === 'welcome')\">\r" +
    "\n" +
    "                    <img src=\"images/spacer.png\" class=\"toolbar-svg home\" ng-if=\"(toolbarItem && toolbarItem !== 'welcome')\">\r" +
    "\n" +
    "                    <div>\r" +
    "\n" +
    "                        {{:: 'Welcome' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>"
  );


  $templateCache.put('/app/views/apFacilityPortal.html',
    "<div ng-if=\"!vm.loadedAngular\">\r" +
    "\n" +
    "    <ap-force-load-angular (angular-initialized)=\"vm.onAngularInitialized()\" />\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div ng-if=\"vm.loadedAngular\">\r" +
    "\n" +
    "    <ap-header ng-if=\"!vm.shouldHideToolbar()\"></ap-header>\r" +
    "\n" +
    "    <ap-toolbar ng-if=\"!vm.shouldHideToolbar()\"></ap-toolbar>\r" +
    "\n" +
    "    <ap-mobile-nav ng-if=\"!vm.shouldHideToolbar()\"></ap-mobile-nav>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-class=\"(vm.shouldHideToolbar())?'ap-main-content':'ap-main-content-toolbar'\">\r" +
    "\n" +
    "        <div\r" +
    "\n" +
    "            id=\"main-content\"\r" +
    "\n" +
    "            ng-class=\"!vm.isLoginView() ? 'ap-application-margin ap-application-content' : 'container-fluid container-flush'\"\r" +
    "\n" +
    "            ui-view>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <toaster-container toaster-options=\"{}\"></toaster-container>\r" +
    "\n" +
    "        <ap-footer ng-if=\"!vm.shouldHideFooter()\"></ap-footer>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/app/views/modals/multiDownloadModal.html',
    "<div>\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div class=\"col-xs-12\">\r" +
    "\n" +
    "            <div class=\"modal-header\">\r" +
    "\n" +
    "                <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                <multi-checkbox selectedlist=\"vm.selectedList\" sourcelist=\"vm.sourceList\"\r" +
    "\n" +
    "                                all=\"vm.all\" sort-by=\"vm.sortBy\"></multi-checkbox>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6\"><button class=\"btn btn-default submit\" ng-disabled=\"vm.Downloading || vm.selectedList.length === 0\" ap-save-to-file=\"vm.downloadMultipleVisits()\">\r" +
    "\n" +
    "                <i class=\"fa fa-download\" ng-hide=\"vm.Downloading\" aria-hidden=\"true\"></i>\r" +
    "\n" +
    "                <ap-spinner ng-show=\"vm.Downloading\"></ap-spinner>\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">{{'Cancel' | translate}}</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/app/views/modals/viewDocumentModal.html',
    "<div class=\"modal-default\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{vm.model.Title}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-body modal-max-height\">\r" +
    "\n" +
    "        <ap-document-viewer-with-download\r" +
    "\n" +
    "            disable-inline-pdf=\"vm.model.DisableInlinePdf\"\r" +
    "\n" +
    "            document-id=\"vm.model.DocumentId\"\r" +
    "\n" +
    "            download-file-name=\"vm.model.DownloadFileName\"\r" +
    "\n" +
    "            enable-download=\"vm.model.EnableDownload\"\r" +
    "\n" +
    "            document-download=\"vm.downloadDocument(documentId)\"\r" +
    "\n" +
    "            document-load=\"vm.loadDocument(documentId, requestSettings)\"\r" +
    "\n" +
    "        ></ap-document-viewer-with-download>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"vm.ok()\">{{::'Close' | translate}}</button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );

}]);
